import axios from 'axios';

const initialState  = {
    sharedByMeCount: 0
};

const state = Object.assign({}, initialState);

const getters = {
    sharedByMeCount: state => state.sharedByMeCount,
};

const actions = {
    async fetchSharedByMeCount({commit}) {
        const response = await axios.get('/v2/sharings/shared_by_me/count');

        commit('setSharedByMeCount', response.data.shared_by_me_count);
    }
};

const mutations = {
    setSharedByMeCount: (state, sharedByMeCount) => (state.sharedByMeCount = sharedByMeCount),
};

export default {
    state,
    getters,
    actions,
    mutations
};